// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1BoDH","noInteraction":"EventWrapper_noInteraction__2h9qX"};